(function(){
var nf=new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP'});
function init(){
 var meter=document.querySelector('[data-x5-cart-progress]');if(!meter)return;
 var threshold=Number(meter.getAttribute('data-threshold'))||3501;
 var root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
 var updating=false,previous=-1;
 async function refresh(){
 if(updating)return;updating=true;
 try{
  var response=await fetch(root+'cart.js',{credentials:'same-origin',headers:{'Accept':'application/json'}});
  if(!response.ok)return;
  var cart=await response.json();
 var total=(cart.items||[]).reduce(function(sum,item){
  return sum+(Number(item.product_id)===11056125346131?(Number(item.final_line_price)||0):0);
 },0);
 if(total===0){meter.hidden=true;return}meter.hidden=false;
  if(total===previous)return;previous=total;
  var pct=Math.max(0,Math.min(100,total/threshold*100));
  var fill=meter.querySelector('[data-x5-progress-fill]');
  var track=meter.querySelector('[data-x5-delivery-track]');
  var label=meter.querySelector('[data-x5-delivery-message]');
  if(fill)fill.style.width=pct+'%';
  if(track)track.setAttribute('aria-valuenow',Math.round(pct));
  if(label){if(total>=threshold)label.textContent="FREE UK DELIVERY — ELIGIBLE XASIS ITEMS ARE OVER £35";else label.textContent="ADD "+nf.format((threshold-total)/100)+" OF ELIGIBLE XASIS ITEMS TO REACH FREE UK DELIVERY";}
 }catch(e){}finally{updating=false}
 }
 refresh();
 var cartForm=document.getElementById('cart');
 if(cartForm){cartForm.addEventListener('change',function(){setTimeout(refresh,650)});cartForm.addEventListener('submit',function(){setTimeout(refresh,850)})}
 document.addEventListener('cart:updated',refresh);
 document.addEventListener('cart:refresh',refresh);
 window.addEventListener('pageshow',function(e){if(e.persisted)refresh()});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();